<div data-cy="text-editor">
  @if (title) {
    <div class="speech-rich-text-input__label block position-initial"
      >{{ title }}{{ isRequired ? '*' : '' }}</div
      >
    }
    @if (hasError && errorMessage) {
      <mat-error>{{ errorMessage }}</mat-error>
    }
    <textarea
      [froalaEditor]="froalaSettings"
      (froalaModelChange)="onChange($event)"
      [(froalaModel)]="model"
      data-cy="text-editor-text-area"
    ></textarea>
  </div>
